if (!customElements.get('holy-manifest-particles')) {
  customElements.define('holy-manifest-particles', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.raf = 0;
      this.onScroll = () => this.queue();
      this.onPointer = event => {
        if (this.reduced || !this.section) return;
        const rect = this.section.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
        const y = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
        this.style.setProperty('--manifest-mx', x.toFixed(3));
        this.style.setProperty('--manifest-my', y.toFixed(3));
      };
      this.onLeave = () => {
        this.style.setProperty('--manifest-mx', '0');
        this.style.setProperty('--manifest-my', '0');
      };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });
      this.section?.addEventListener('pointermove', this.onPointer, { passive: true });
      this.section?.addEventListener('pointerleave', this.onLeave);
      this.update();
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      this.section?.removeEventListener('pointermove', this.onPointer);
      this.section?.removeEventListener('pointerleave', this.onLeave);
      cancelAnimationFrame(this.raf);
    }
    queue() {
      if (this.raf || this.reduced) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.update();
      });
    }
    update() {
      if (this.reduced || !this.section) return;
      const rect = this.section.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
      this.style.setProperty('--manifest-scroll', ((progress - .5) * 2).toFixed(3));
    }
  });
}
